export default {"src":"https://dap-dbh3q7xqw-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};